var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 1.334A1.333 1.333 0 1 1 0 1.333a1.333 1.333 0 0 1 2.667 0zm.04 2.32H.04V12h2.667V3.654zm4.213 0H4.267V12h2.626V7.62c0-2.44 3.18-2.667 3.18 0V12h2.634V6.714c0-4.113-4.707-3.96-5.814-1.94l.027-1.12z",
    fill: "#020842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon_linkedin.db8ed0a787946e929fba25ff8833b393.svg";
export { ForwardRef as ReactComponent };